import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  GetAllProductsApi,
  GetProductCategoriesApi,
  GetSingleProductsApi,
} from "../../api/product-processing-api/ProductProcessingApi";

// Async thunks for API calls
export const GetAllProducts = createAsyncThunk(
  "product/GetAllProducts",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await GetAllProductsApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const GetSingleProducts = createAsyncThunk(
  "product/GetSingleProducts",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await GetSingleProductsApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const GetProductCategories = createAsyncThunk(
  "product/GetProductCategories",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await GetProductCategoriesApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

// Initial state

const initialState = {
  loading: false,
  products: {},
  singleProduct: {},
  page: 0,
  size: 15,
  sortBy: "",
  sortDir: "",
  search: "",
  minPrice: 0,
  maxPrice: 5000,
  categoryType: 0,
  ageFilter: "",
  genderFilter: "",
  themeFilter: "",
  categories: [],
  isClearAll: false,
};

// Slice definition
const ProductProcessingSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setSingleProduct: (state, action) => {
      state.singleProduct = action.payload;
    },
    addKeyword: (state, { payload }) => {
      state.search = payload;
      state.isClearAll = true;
    },
    addPrice: (state, { payload }) => {
      state.minPrice = payload?.min || 99;
      state.maxPrice = payload?.max || 10000;
      state.isClearAll = true;
    },
    addSortBy: (state, { payload }) => {
      state.sortBy = payload;
      state.isClearAll = true;
    },
    addSortDir: (state, { payload }) => {
      state.sortDir = payload;
      state.isClearAll = true;
    },
    addCategory: (state, { payload }) => {
      state.categoryType = payload || 0;
      state.isClearAll = true;
    },
    addAgeFilter: (state, { payload }) => {
      state.ageFilter = payload || "";
      state.isClearAll = true;
    },
    addGenderFilter: (state, { payload }) => {
      state.genderFilter = payload || "";
      state.isClearAll = true;
    },
    addThemeFilter: (state, { payload }) => {
      state.themeFilter = payload || "";
      state.isClearAll = true;
    },
    addPage: (state, { payload }) => {
      state.page = payload || 0;
      state.isClearAll = true;
    },
    addSize: (state, { payload }) => {
      state.size = payload || 10;
      state.isClearAll = true;
    },
    clearAllFilters: (state, { payload }) => {
      state.page = 0;
      state.search = "";
      state.categoryType = 0;
      state.minPrice = 0;
      state.maxPrice = 5000;
      state.sortBy = "";
      state.sortDir = "";
      state.ageFilter = "";
      state.genderFilter = "";
      state.themeFilter = "";
      state.isClearAll = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllProducts.pending, (state) => {
        state.loading = true;
        // state.products = [];
      })
      .addCase(GetAllProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload.response;
      })
      .addCase(GetAllProducts.rejected, (state) => {
        state.loading = false;
        state.products = [];
      });

    builder
      .addCase(GetSingleProducts.pending, (state) => {
        state.loading = true;
        state.singleProduct = {};
      })
      .addCase(GetSingleProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.singleProduct = action.payload.response;
      })
      .addCase(GetSingleProducts.rejected, (state) => {
        state.loading = false;
        state.singleProduct = {};
      });

    builder
      .addCase(GetProductCategories.pending, (state) => {
        state.loading = true;
        state.categories = [];
      })
      .addCase(GetProductCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload.response;
      })
      .addCase(GetProductCategories.rejected, (state) => {
        state.loading = false;
        state.categories = [];
      });
  },
});

export const {
  setSingleProduct,
  addCategory,
  addAgeFilter,
  addGenderFilter,
  addThemeFilter,
  addKeyword,
  addPrice,
  addSortBy,
  addSortDir,
  addPage,
  addSize,
  clearAllFilters,
} = ProductProcessingSlice.actions;
export default ProductProcessingSlice.reducer;
